export enum EntityType {
  ADDRESS = 'ADDRESS',
  AMENITY = 'AMENITY',
  COMMUNITY = 'COMMUNITY',
  FILE = 'FILE',
  FLOOR_PLAN = 'FLOOR_PLAN',
  PROPERTY = 'PROPERTY',
  UNIT = 'UNIT',
}

export type Entities = Partial<Record<EntityType, number[]>>;
